const formatDateToRomanian = (isoDateString) => {
    const date = new Date(isoDateString);
  
    const daysOfWeek = [
      "Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"
    ];
  
    const monthsOfYear = [
      "Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
      "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"
    ];
  
    const dayOfWeek = daysOfWeek[date.getDay()];
    const day = date.getDate();
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
  
    return `${dayOfWeek}, ${day} ${month} ${year}`;
  };
  
  export default formatDateToRomanian

  